import { HeaderIcon } from 'components/mobile/organisms';
import { SlotComponentProps } from 'modules/page-builder/types';

export type SearchBarRightItemsMobileProps = SlotComponentProps<{}>;

export const SearchBarRightItemsMobile: React.FC<
  SearchBarRightItemsMobileProps
> = ({}) => {
  return (
    <HeaderIcon
      isVisible={true}
      isShowCartIcon
      onlyShowLocationIcon
      transitionDelay="0.3s"
    />
  );
};
